import { RichText as SitecoreRichText } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

type RichTextProps = {
  text?: string;
  className?: string;
  isActive?: boolean;
};

const getHtmlListStyle = (type: 'ul' | 'ol') => `
  [&_${type}]:pl-7 
  [.dark_&_${type}]:marker:text-white 
  [.light_&_${type}]:marker:text-black
`;
const linkStyle = '[&_a]:after:content-[""]';

const ulStyles = `[&_ul]:list-disc ${getHtmlListStyle('ul')}`;
const olStyles = `[&_ol]:list-decimal ${getHtmlListStyle('ol')}`;

const RichText = ({ text, className, isActive = true }: RichTextProps) => {
  if (!text) return null;
  return (
    <SitecoreRichText
      field={{ value: text }}
      className={classNames(className, ulStyles, olStyles, linkStyle, isActive ? '' : 'max-h-20')}
    />
  );
};

export default RichText;
